export default __webpack_public_path__ + "static/media/flow-chart.5b870dc8.svg";